import { useState, useEffect } from 'react'

/**
 * Returns `true` only after the component has mounted on the client (post-hydration).
 *
 * **Use this hook when you need a state-based re-render after mount** — typically to avoid
 * SSR/client HTML mismatches when rendering depends on client-only values (config flags, atoms, etc.)
 *
 * ⚠️ **Do NOT replace with `useIsMounted` from `usehooks-ts`**: that hook uses a `ref`, which does
 * not trigger a re-render. Components relying on a re-render to exit their skeleton/loading state
 * will be stuck forever if `useIsMounted` is used instead of this hook.
 *
 * Only reach for this hook when truly necessary (SSR mismatch, client-only APIs).
 * Prefer server-safe data or proper loading states when possible.
 */
export function useNextIsClientHydrated(): boolean {
  const [isHydrated, setIsHydrated] = useState(false)

  useEffect(() => {
    setIsHydrated(true)
  }, [])

  return isHydrated
}
